module.exports = {
    CORRESPONDENCE_ADDRESS_TYPE : 'correspondence',
    CORRESPONDENCE_ADDRESS_CODE: '05',
    NEW_SHIPPING_ADDRESS : 'newShippingAddress',
    LAST_ADDED_SHIPPING_ADDRESS_CODE: '13',
    LAST_ADDED_SHIPPING_ADDRESS_TYPE: 'lastAddedShippingAddress',
    PERMANENT_ADDRESS_TYPE: 'permanent',
    PERMANENT_ADDRESS_CODE: '01'
};
